import { doHttp } from '../util/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../util/constants'

/**
 * 首页轮播图
 * @param limitCount
 * @returns {*}
 */
export function apiHomeAdvertisement (limitCount) {
  let params = {
    limitCount
  }

  return doHttp('/adv/v1/getNewAdvList', HTTP_TYPE_POST, params)
}

/**
 * 今日头条
 * @param limitCount
 * @returns {*}
 */
export function apiHomeLatestTop (limitCount) {
  let params = {
    limitCount
  }

  return doHttp('/news/v1/getLatestTopNewsList', HTTP_TYPE_POST, params)
}



// WEBPACK FOOTER //
// ./src/api/home.js